// ── 관리자 위장 접속 표시 (Step 8 복원, 2026-04-27) ──────────────────────────
// AdminLayout 안 글로벌 렌더 (모든 /my/*, /admin/* 페이지에서 위장 접속 시 표시)
// 상단 가운데 알약형 뱃지 + 화면 가장자리 딥 인디고 테두리 프레임 (내용 안 가림)
import React from 'react';
import { apiClient } from '../../api/apiClient';

/**
 * 위장 접속 알약 뱃지 + 화면 가장자리 테두리 프레임
 * @param {string} userName — 접속 대상 직원 이름 (없으면 '직원')
 */
export function ImpersonationBadge({ userName }) {
  return (
    <>
      {/* 화면 가장자리 딥 인디고 테두리 프레임 — 내용 0px 가림(중앙 투명·border만) + pointer-events-none
          은은한 내부 글로우로 고급스러운 깊이. (이전: 상단 64px 배경띠가 헤더를 가리던 문제 → 프레임) */}
      <div
        className="fixed inset-0 z-[9998] pointer-events-none"
        style={{ border: '3px solid rgba(79, 70, 229, 0.85)', boxShadow: 'inset 0 0 14px rgba(79, 70, 229, 0.18)' }}
      />
      {/* 상단 가운데 알약 뱃지 — fixed 위치, safe-area 대응 */}
      <div
        className="fixed z-[9999] left-1/2 -translate-x-1/2 flex items-center gap-2"
        style={{ top: 'max(4px, env(safe-area-inset-top))' }}
      >
        <div
          className="flex items-center gap-1.5 px-3 py-1 rounded-full shadow-md"
          style={{ background: 'rgba(79, 70, 229, 0.92)', backdropFilter: 'blur(8px)' }}
        >
          <span className="text-[11px] font-bold text-white whitespace-nowrap">
            👤 {userName || '직원'}
          </span>
          <button
            onClick={() => apiClient.exitImpersonation()}
            className="text-[10px] font-bold text-white/80 hover:text-white bg-white/20 hover:bg-white/30 rounded-full px-2 py-0.5 transition-colors whitespace-nowrap"
          >
            종료
          </button>
        </div>
      </div>
    </>
  );
}
